import { createContext } from 'react';

export interface LayoutContextType {
  hasSidebar: boolean;
  registerSidebar: () => void;
  unregisterSidebar: () => void;
  toggleSidebar: () => void;
  sidebarCollapsed: boolean;
}

export const LayoutContext = createContext<LayoutContextType | undefined>(
  undefined
);
